/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationExclusionRuleBase {
    getFixupPrototypeFunction() { return RecommendationExclusionRuleBase.fixupPrototype; }

    static newInstance(model: Partial<RecommendationExclusionRuleBase>): RecommendationExclusionRuleBase {
        let obj = Object.assign(new RecommendationExclusionRuleBase(), model);
        RecommendationExclusionRuleBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationExclusionRuleBase>): RecommendationExclusionRuleBase {
        if (!model) return null;
        return RecommendationExclusionRuleBase.newInstance(<RecommendationExclusionRuleBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationExclusionRuleBase) {
        if (!obj) return;

        models.RecommendationExclusionRuleBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationExclusionRuleBase): boolean {
        Object.setPrototypeOf(obj, RecommendationExclusionRuleBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.activation_date === "string") {
            this.activation_date = new Date(<string><any>this.activation_date);
        }
        if (typeof this.expiry_date === "string") {
            this.expiry_date = new Date(<string><any>this.expiry_date);
        }
        if (this.resource_scope) {
            models.RecommendationResourceScopeBase.fixupPrototype(this.resource_scope);
        }
    }

    /**
     * Recommendation Exclusion Rule Name
     */
    name: string;

    /**
     * Rule Activation date
     */
    activation_date: Date;

    /**
     * Rule Description
     */
    description: string;

    /**
     * Rule expiry date
     */
    expiry_date: Date;

    /**
     * Rule status
     */
    is_enabled: boolean;

    /**
     * Rule Scope
     */
    scope: models.RecommendationExclusionRuleScope;

    /**
     * Filter for the rule.
     */
    resource_scope: models.RecommendationResourceScopeBase;

}
